//======================================================================================
//RUNS A CALLBACK FUNCTION WHEN THE DOM IS LOADED, OR WHEN A SPECIFIED ELEMENT IS LOADED
//======================================================================================

export function domReady(callback, elementToWaitOn = "") {
  let waitForDomToLoad = elementToWaitOn === "";
  let waitForElementToLoad = elementToWaitOn.length >= 1;

  if (waitForDomToLoad) {
    handleDomLoading(callback);
  }

  if (waitForElementToLoad) {
    handleWaitingOnElement(callback, elementToWaitOn);
  }
}

function handleDomLoading(callback) {
  document.readyState === "interactive" || document.readyState === "complete"
    ? callback()
    : document.addEventListener("DOMContentLoaded", callback);
}

function handleWaitingOnElement(callback, elementToWaitOn) {
  let iterations = 0;

  let waitTimer = window.setInterval(() => {
    let pastMaxIterations = iterations >= 100;
    let elementHasBeenFound = document.querySelector(elementToWaitOn);

    if (elementHasBeenFound) {
      callback();
      window.clearInterval(waitTimer);
    }

    if (pastMaxIterations) {
      stopWaiting(waitTimer, elementToWaitOn);
    }

    iterations++;
  }, 100);
}

function stopWaiting(waitTimer, elementToWaitOn) {
  window.clearInterval(waitTimer);
  console.warn(
    `domReady timed out, couldn't find the element '${elementToWaitOn}' on the page`
  );
}
